import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withResizeDetector } from 'react-resize-detector/build/withPolyfill';
import CloseIcon from '../../legacy/flux/components/misc/CloseIcon.react';

class OpenImage extends Component {
  componentDidMount() {
    document.body.addEventListener('keydown', this.onKeyDown);

    if (!window.history.state || (window.history.state.gallery || '') !== document.location.href) {
      window.history.pushState({
        gallery: document.location.href,
      }, document.title, window.location.href);
    }
    const { onClose } = this.props;
    window.addEventListener('popstate', onClose);
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.onKeyDown);

    const { onClose } = this.props;
    window.removeEventListener('popstate', onClose);
    if (window.history.state && (window.history.state.gallery || '') === document.location.href) {
      window.history.back();
    }
  }

  onKeyDown = (e) => {
    if (e.keyCode === 27) {
      this.props.onClose();
    }
  };

  mainHeight = () => {
    const windowHeight = window.innerHeight;

    if (windowHeight < 400) {
      return windowHeight;
    }

    const mainHeight = windowHeight - 100;
    return mainHeight > 668 ? 668 : mainHeight;
  };

  render() {
    const { src, onClose } = this.props;

    return (
      <div
        className="galleryContainer"
        role="button"
        tabIndex="0"
        onClick={onClose}
        onKeyDown={onClose}
      >
        <div className="galleryContainer-box">
          <div style={{ height: this.mainHeight() }}>
            <div className="galleryBoxMain">
              <div className="galleryImage">
                <div className="galleryImage-inner">
                  <img src={src} alt="" />
                </div>
              </div>
              <div className="galleryBoxMain-close">
                <CloseIcon large onClick={onClose} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

OpenImage.propTypes = {
  src: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

OpenImage.defaultProps = {
  src: '',
};

export default withResizeDetector(OpenImage);
